import type {
  PortalInboxParams,
  PortalThreadParams,
} from "@/types/portalMessages";

export const portalMessageQueryKeys = {
  all: ["portalMemberMessages"] as const,
  conversations: ["portalMemberMessages", "conversations"] as const,
  unreadCount: () => [...portalMessageQueryKeys.all, "unreadCount"] as const,
  conversationList: (params: PortalInboxParams) =>
    [...portalMessageQueryKeys.conversations, params] as const,
  threads: ["portalMemberMessages", "threads"] as const,
  thread: (memberId: string) =>
    [...portalMessageQueryKeys.threads, memberId] as const,
  threadCursor: (memberId: string, params: Pick<PortalThreadParams, "limit">) =>
    [...portalMessageQueryKeys.thread(memberId), "cursor", params] as const,
  threadPage: (memberId: string, params: PortalThreadParams) =>
    [...portalMessageQueryKeys.thread(memberId), params] as const,
  messageHistory: (messageId: string) =>
    [...portalMessageQueryKeys.all, "history", messageId] as const,
};
